import React from 'react'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import { useValue } from '@morningtrain/react-resources'
import { ProductInfo } from 'ui/elements'
import EnvToModel from 'support/helpers/EnvToModel'
import WhenCanAdjustInventoryOrder from 'pages/app/inventory/order/partials/WhenCanAdjustInventoryOrder'
import { Translation } from '@morningtrain/react-translations'

export default function PendingOrderColumns (props) {
  const itemId = useValue('id')

  return (
    <>
      <Columns.Column className='w-full'>
        <ProductInfo
          image={<Displays.Image name='image' className='max-h-full' />}
          title={<Displays.Text name='name' />}
          text={(<>min. <Displays.Integer name='min_unit' /> <Displays.Text name='unit_type' /></>)}
        />
      </Columns.Column>
      <EnvToModel path={['globals.inventory.order_items', itemId].join('.')}>
        <WhenCanAdjustInventoryOrder>
          <Columns.Number
            name='norm'
            alignment='center'
            label={<Translation name='inventory.columns.expected_usage' />}
            decimals={0}
          />
        </WhenCanAdjustInventoryOrder>
        <Columns.Number
          name='holdings'
          alignment='center'
          label={<Translation name='inventory.columns.in_stock' />}
          decimals={0}
        />
        <WhenCanAdjustInventoryOrder>
          <Columns.Number
            name='suggestion'
            alignment='center'
            label={<Translation name='inventory.columns.suggested' />}
            decimals={0}
          />
          <Columns.Number
            name='adjustment'
            alignment='center'
            label={<Translation name='inventory.columns.deviation' />}
            decimals={0}
          />
          <Columns.Number
            name='total'
            alignment='center'
            label={<Translation name='inventory.columns.order_total' />}
            decimals={0}
          />
        </WhenCanAdjustInventoryOrder>
      </EnvToModel>
    </>
  )
}
